<template>
  <DialogHeader class="p-3 h-[56px] mb-0!">
    <div
      class="w-[70px] h-8 text-white text-[14px] leading-[22px] font-secondary font-medium mr-[17px] rounded-md bg-yellow-500 flex items-center justify-center"
    >
      <Icon name="Lightbulb" class="stroke-white mr-1.5" :size="22" />
      Tips
    </div>
    <div>Co-owners and authors</div>
  </DialogHeader>
  <DialogContent>
    <img
      :src="OwnersAuthorsTipImage"
      class="mb-[19px] border-t border-b border-gray-800/15"
    />
    <div class="px-[30px]">
      <div class="font-primary font-semibold text-[17px] leading-[24px] mb-2.5">
        Add co-owners and authors
      </div>
      <div>
        Invite co-owners and authors to your copyrighted work to attribute
        credit and for a complete accurate record.
      </div>
    </div>
  </DialogContent>
  <DialogFooter class="px-[30px] pb-[25px] justify-between!">
    <div class="font-secondary text-[13px] leading-[22px] text-gray-400">
      1 of 2
    </div>
    <UiButton primary @click="handleClick"> Okay </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import OwnersAuthorsTipImage from '@/assets/images/owners-authors-tip.png'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { Dialogs } from '@/shared/dialogs/types'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Icon, UiButton } from '@dacr/ui'

const { open } = useDialog()

const handleClick = () => {
  open(Dialogs.ManageAccessTip)
}
</script>
